import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';


import React, { useState, useEffect } from 'react';
/*  */

import { BagXFill, BagDash, BagPlus } from 'react-bootstrap-icons';
import ImageContainer from '../blocks/UIImageContainer';
import { GetHeaders, PostDataFetch } from '../../hooks/DataFetch';
import { INTRFItem } from '../../hooks/Interfaces';

interface CartItemProps {
    /*itemid: string;*/
    itemid: string;
    name: string;
    image: string;
    quantity: number;
    total: number;
    price: number;
    appupdate: () => void;
}

function CartItem({itemid, name, image, quantity, total,price, appupdate}: CartItemProps){
    const [isVisible, setIsVisible] = useState(true);
    const [itemName, setItemName] = useState(name);
    const [itemQuantity, setItemQuantity] = useState(quantity);
    const [itemTotal, setItemTotal] = useState(total);

    /* Component Init */

    const axiosConfig = GetHeaders();
    

    

    const updateCartedItem = (itemid: string, count: number): void => {
    /* Probably going to break if not logged in */
        const posturl = process.env.REACT_APP_API_URL + "/v1/commerce/cart/update";
        const iteminfo = {
            'product_id': itemid,
            'count': count
        }
        const GetInventory = async () => {
            //setLoading(true);
            let response = await PostDataFetch({url: posturl, headers: axiosConfig, data: iteminfo})
            //Handle a Non 200 response
            setItemQuantity(itemQuantity + count)
            appupdate()
        }

        GetInventory();

    }
    
    return (
        <> 
            <tr>
                <td><button type="button" className="btn btn-danger" onClick={(e) => updateCartedItem(itemid, (-1 * itemQuantity))}><BagXFill size={16} /></button></td>
                <td>
                    <div className="square-image-block">
                        <ImageContainer img_url={image} />
                    </div>
                </td>
                <td>
                    
                    <div>
                        <p className="text-font-body text-font-size-tiny text-font-light">{name}</p>
                    </div>
                </td>
                <td><button type="button" className="d-inline btn brand-btn-tertiary-color style-circle-container" onClick={(e) => updateCartedItem(itemid, 1)}><BagPlus size={12} /></button></td>
                <td>
                    <div>
                        <p className="d-inline text-font-body text-font-size-small text-font-light text-start">${price.toFixed(2)}</p>
                        <p className="d-inline text-font-body text-font-size-tiny text-font-light text-start"> (x{itemQuantity})</p>
                    </div>
                    <div>
                        
                        
                    </div>
                    
                    
                </td>
                <td><button type="button" className="d-inline btn brand-btn-tertiary-color style-circle-container" onClick={(e) => updateCartedItem(itemid, -1)}><BagDash size={12} /></button></td>
                
                <td><p className="d-inline text-font-body text-font-size-small text-font-light text-start">${total.toFixed(2)}</p></td>

                
            </tr>
        </>
    )
}

export default CartItem;